/* eslint-disable no-unused-vars */
import React, { useContext, useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'

import {
  getSolarEntity,
  saveSolarEntity,
  deleteSolarEntity,
  renameSolarEntity,
} from 'api/pgads.js'

import CommonScreen from 'admin/component/CommonScreen'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { Label } from 'core/screen-util'
import { Button, Input } from 'antd'
import { HistoryModal, RenameModal } from './SolarStorageGroup'
import { ErrorContext } from 'context'

const SolarEntity = _ => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [showRenameModal, setShowRenameModal] = useState(false)
  const [showHistoryModal, setShowHistoryModal] = useState(false)

  const { setError } = useContext(ErrorContext)

  const insertComp = ({ insertData = {}, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '100px 200px 100px 300px',
          gap: 10,
        }}
      >
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Entity Id :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        <Input
          value={insertData.entityId}
          placeholder="Entity Id"
          onChange={e =>
            setInsertData({
              ...insertData,
              entityId: e.target.value,
            })
          }
        />
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Entity Name :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        <Input
          value={insertData.entityName}
          placeholder="Entity Name"
          onChange={e =>
            setInsertData({
              ...insertData,
              entityName: e.target.value,
            })
          }
        />
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: 5,
            gridColumnStart: '3',
            gridColumnEnd: 'span 2',
          }}
        >
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>
          <Button type="primary" onClick={() => onAdd(false)}>
            Add & Hide
          </Button>
          <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  const extraCriteriaAfterButton = ({
    data,
    onRetrieve,
    apiTargetInfo,
    setSpinning,
  }) => {
    return (
      <div>
        {showRenameModal && (
          <RenameModal
            list={data.map(e => ({
              label: e.entityId,
              value: e.entityId,
            }))}
            modalFor="Entity"
            hide={() => setShowRenameModal(false)}
            onOk={data => {
              const { oldId, newId } = data

              setSpinning(true)
              renameSolarEntity(apiTargetInfo)({
                oldId,
                newId,
              }).fork(setError, _ => {
                setSpinning(false)
                onRetrieve()
              })
            }}
          />
        )}
        {showHistoryModal && (
          <HistoryModal
            dataName="ENTITY"
            apiTargetInfo={apiTargetInfo}
            setError={setError}
            hide={() => setShowHistoryModal(false)}
          />
        )}
        <Button
          onClick={() => setShowRenameModal(true)}
          type="primary"
          // style={{ marginLeft: '10px' }}
        >
          Rename Entity
        </Button>
        <Button
          onClick={() => setShowHistoryModal(true)}
          type="primary"
          style={{ marginLeft: '10px' }}
        >
          Show Rename History
        </Button>
      </div>
    )
  }

  return (
    <CommonScreen
      title="Solar Entity"
      header={Wind2SolarManufacturerHeaders}
      sortOptions={Wind2SolarManufacturerHeaders}
      saveTask={saveSolarEntity}
      retrieveTask={getSolarEntity}
      deleteTask={deleteSolarEntity}
      autoRetrieve
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      totalWidth={850}
      // heightOffset={100}
    />
  )
}

export default SolarEntity

const Wind2SolarManufacturerHeaders = [
  strCol({
    ident: 'entityId',
    display: 'Entity Id',
    isKey: true,
    width: 250,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'entityName',
    display: 'Entity Name',
    isRequired: true,
    width: 250,
    sortOrder: 'asc',
  }),

  modifierCol,
  modifiedDateCol,
]
